import React from "react";

function Banner() {
  return (
    <div>
      <div className="banner">
        <img
          src="header.png"
          alt=""
        />
      </div>
    </div>
  );
}

export {Banner};